import { render, staticRenderFns } from "./CampaignName.vue?vue&type=template&id=e490871a&"
import script from "./CampaignName.vue?vue&type=script&lang=js&"
export * from "./CampaignName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports